import { useEffect, useState } from 'react';
import { useLazyQuerySimplePipelinesByCluster } from '@ion/api';

export default function usePipelineSelection({ clusterId }) {
  const [selectedPipelineId, setSelectedPipelineId] = useState(null);
  const [getPipelines, { pipelines, loading }] = useLazyQuerySimplePipelinesByCluster();

  useEffect(() => {
    if (clusterId) {
      getPipelines(clusterId);
    }
    // getPipelines is recreated each render; the list only needs refetching when the cluster changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clusterId]);

  const onSelectPipeline = pipelineId => setSelectedPipelineId(pipelineId || null);
  const clearSelection = () => setSelectedPipelineId(null);
  const options = pipelines.map(pipeline => ({ label: pipeline.name, value: pipeline.id }));

  return { pipelines, options, loading, selectedPipelineId, onSelectPipeline, clearSelection };
}
